import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type ManageEmptyProps = ComponentProps<"div">

function ManageEmpty(props: ManageEmptyProps) {
  const { className, children, ...divProps } = props
  return (
    <div className={cn("manage-empty", className)} {...divProps}>
      {children}
    </div>
  )
}

export default ManageEmpty
